import { Box, IconButton, Stack, TextField } from "@mui/material"
import { useContext, useState } from "react";
import Slide from "@mui/material/Slide";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import useSectionChange from "../Hooks/useSectionChange";
import { useNavigate } from "react-router-dom";
import API from "../../../services/API";
import ToastContext from "../../../services/Context/ToastContext";
import { ArrowForward } from "@mui/icons-material";
import { txt } from "../../../services/translation";

export default function Note({section}){

    const {course, tab} = useParams()

    const navigate = useNavigate()

    const {setToast} = useContext(ToastContext)

    const [open, setOpen] = useState(true)

    const [note, setNote] = useState('');

    useEffect(() => {

        setNote(section?.note || '')

        return () => {
            const input = document.getElementById('study-note');
            const note = input?.value;
            saveNote(section.id, note)
        }

    }, [section])

    const changeSection = useSectionChange();

    const handleSubmit = e => {
        e.preventDefault();

        setOpen(false)

        saveNote(section.id, note)
            .then(_ => changeSection({...section, note}))
            .catch(_ => setToast({severity: 'error', message: txt('notesSaveError')}))
            .finally(() => navigate(`/study/${course}/${tab}`))
    }

    return <>

        <Slide direction={slide} in={open} mountOnEnter unmountOnExit>

            <form onSubmit={handleSubmit}>

                <Stack direction='column' spacing={2} width={250} sx={{m: 1}}>

                    <Box>
                        <IconButton type='submit'>
                            <ArrowForward />
                        </IconButton>
                    </Box>

                    <TextField
                        id="study-note"
                        label={txt('myNotes')}
                        value={note || ''}
                        onChange={e => setNote(e.target.value)}
                        inputProps={{
                            maxLength: 2000
                        }}
                        multiline
                        minRows={10}
                        autoFocus
                    />

                </Stack>

            </form>

        </Slide>

    </>

}


const slide = window.screen.width < 800 ? 'up' : 'left';


async function saveNote(sectionId, note){
    return await API.post(`/study/sections/${sectionId}/note`, {content: note});
}